import React from 'react'
import styled from 'styled-components'
import Select, { components } from 'react-select'
import colors from 'styles/colors'
import { ErrorMessage } from 'formik'
import FormErrorMessage from './FormErrorMessage'
import FormCheckbox from './FormCheckbox'

const customStyles = {
  placeholder: provided => ({
    ...provided,
    color: colors.placeholderColor,
    fontWeight: 300,
  }),
  option: provided => ({
    ...provided,
    color: 'currentColor',
    backgroundColor: 'transparent',
    padding: '16px 16px 6px',
  }),
  container: () => ({
    position: 'relative',
    width: '100%',
    outline: 'none',
  }),
  control: (provided, state) => ({
    ...provided,
    borderRadius: '7px',
    minHeight: '46px',
    lineHeight: '24px',
    paddingLeft: 0,
    borderColor: state.isFocused ? `${colors.greenMain} !important` : '#e8ecf3',
    boxShadow: state.isFocused ? `0 0 0 1px ${colors.greenMain}` : 'none',
  }),
  valueContainer: provided => ({
    ...provided,
    paddingLeft: 16,
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    color: colors.greenMain,
  }),
}

const StyledOption = styled(components.Option)`
  && {
    cursor: pointer;

    &:active {
      background-color: ${colors.greenMain}80 !important;
    }

    label {
      z-index: -1;
    }
  }
`

const CustomOption = ({ ...props }) => (
  <StyledOption {...props}>
    <FormCheckbox
      label={props.label}
      value={props.value}
      isSelected={props.isSelected}
    />
  </StyledOption>
)

const CategoryForm = ({ field, form, placeholder, options }) => (
  <>
    <Select
      components={{ Option: CustomOption }}
      options={options}
      name={field.name}
      placeholder={placeholder}
      styles={customStyles}
      value={
        options ? options.find(option => option.value === field.value) : []
      }
      onChange={newFieldState =>
        form.setFieldValue(
          field.name,
          newFieldState.map(({ value }) => value)
        )
      }
      isMulti
      hideSelectedOptions={false}
      closeMenuOnSelect={false}
    />
    <ErrorMessage component={FormErrorMessage} name={field.name} />
  </>
)

export default CategoryForm
